import { render, staticRenderFns } from "./LottieView.vue?vue&type=template&id=45545413&"
import script from "./LottieView.vue?vue&type=script&lang=js&"
export * from "./LottieView.vue?vue&type=script&lang=js&"
import style0 from "./LottieView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports